import styled from 'styled-components';

import {grey, white} from '@drivesally/sally-ui/lib/libs/colors';

const MemberRow = styled.div`
  align-items: center;
  background: ${white};
  display: flex;
  gap: 12px;
  padding: 10px 20px;

  &:hover {
    background: ${grey};
  }
`;

export default MemberRow;
